import cx from 'classnames'

import ProductGameTile from 'containers/ProductGameTile'
import { format2RowSwimlane } from 'pageContainers/Home/utils/format2RowSwimlane'
import GameRowHeader from 'src/components/GameRowHeader'
import HorizontalScroll from 'src/containers/HorizontalScroll'

import classes from './styles.module.scss'

import type { GameProductShort } from '@patrianna/shared-patrianna-types/store/GameModule'

type Props = {
  games: Array<GameProductShort>
  title: string
  url?: string
  lines?: number
  count?: number
  iconImg?: string
  code: string
  swimlaneIndex: number
  is3DTilesEnabled: boolean
  layout: string
}

export default function SlotsRow(props: Props) {
  const { games, lines, swimlaneIndex, is3DTilesEnabled, layout, ...headerProps } = props
  const shuffledGames = props.code === 'new' && lines === 2 ? format2RowSwimlane(games) : games

  if (props.games?.length) {
    return (
      <>
        <GameRowHeader {...headerProps} with3DImage={is3DTilesEnabled} />
        <HorizontalScroll
          with3DImage={is3DTilesEnabled}
          data-test={`${props.title}-games-row`}
          classNameContainer={cx(
            classes.root,
            is3DTilesEnabled ? classes.slotsContainerRoot3D : classes.slotsContainerRoot,
          )}
          linesAmount={lines}
          styleContainer={{
            gridTemplateRows: `repeat(${lines}, auto)`,
          }}
        >
          {shuffledGames.map((game, index) => (
            <ProductGameTile
              with3DImage={is3DTilesEnabled}
              game={game}
              category={props.title}
              gameIndex={index + 1}
              swimlaneIndex={swimlaneIndex}
              showFavorite
              layout={layout}
              key={`${props.title}-${game.code}`}
            />
          ))}
        </HorizontalScroll>
      </>
    )
  }

  return null
}
